// Both return the promise for the refetches they trigger, so a caller that must not re-enable an
// action until the list has actually caught up can await them. Callers that only want the caches
// warmed can keep ignoring the return value.

/** Route params arrive as strings and entities carry numbers; both must hit the same cache entry. */
export const clientInvoicesQueryKey = (clientId) => [
  "client-invoice-verifications",
  Number(clientId),
];

export const refreshPendingVerificationQueries = (queryClient) =>
  Promise.all([
    queryClient.invalidateQueries(["invoice-verification-pending-count"]),
    queryClient.invalidateQueries(["invoice-verification-pending"]),
    queryClient.invalidateQueries(["invoice-activation-pending-count"]),
    queryClient.invalidateQueries(["invoice-activation-pending"]),
    queryClient.refetchQueries({ queryKey: ["invoice-verification-pending-count"], type: "all" }),
    queryClient.refetchQueries({ queryKey: ["invoice-verification-pending"], type: "all" }),
    queryClient.refetchQueries({ queryKey: ["invoice-activation-pending-count"], type: "all" }),
    queryClient.refetchQueries({ queryKey: ["invoice-activation-pending"], type: "all" }),
  ]);

export const refreshInvoiceVerificationCaches = (queryClient) =>
  Promise.all([
    queryClient.invalidateQueries(["invoice"]),
    queryClient.invalidateQueries(["invoiceSummary"]),
    // The sidebar's outstanding-invoice badge reads this; a verified payment changes it.
    queryClient.invalidateQueries(["dashboardStats"]),
    queryClient.invalidateQueries(["outstandingInvoices"]),
    queryClient.invalidateQueries(["client-invoice-verifications"]),
    queryClient.refetchQueries({ queryKey: ["client-invoice-verifications"], type: "all" }),
    refreshPendingVerificationQueries(queryClient),
  ]);
